import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'

import { apiFetch } from './api'

export default function Dashboard(){
  const [user,setUser]=useState(null)
  const [loading,setLoading]=useState(true)

  const [loggingOut,setLoggingOut]=useState(false)
  const [companyStock,setCompanyStock]=useState({})
  const nav = useNavigate()

  const companies = [
     { key:'kanika-milk-center', name:'Kanika Milk Centre', path:'/kanika-milk-center', company:'kanika-milk-center' },
    { key:'shree-kanika-milk', name:'Sree Kanika Dairy', path:'/shree-kanika-milk', company:'Shree Kanika Milk' },
    { key:'doctor-kanika', name:'Doctor Kanika', path:'/doctor-kanika', company:'doctor-kanika' },
  ]

  const roles = user?.roles || []
  const isAdmin = roles.includes('ROLE_ADMIN')
  const isOperator = roles.includes('ROLE_OPERATOR')
  const isSupervisor = roles.includes('ROLE_SUPERVISOR')
  const companiesForUser = user?.supervisorCompany ? companies.filter(c => c.company === user.supervisorCompany) : companies

  const logout = async () => {
    setLoggingOut(true)
    try {
      await apiFetch('/api/logout', {method: 'POST', credentials: 'include'})
    } catch (e) {
      // ignore network errors
      console.warn('Logout request failed', e)
    } finally {
      nav('/login')
    }
  }

  useEffect(()=>{
    document.title = 'Kanika Group of Companies'
    apiFetch('/api/me', {credentials:'include'})
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data){
          nav('/login')
          return
        }
        setUser(data)
        // sample, production-ready dashboards would fetch real metrics here
        const companyList = (data.supervisorCompany ? companies.filter(c => c.company === data.supervisorCompany) : companies)
        if (companyList.length){
          apiFetch(`/api/stock/summary/bulk?companies=${companyList.map(c=>encodeURIComponent(c.company)).join(',')}`, {credentials:'include'})
            .then(res => res.ok ? res.json() : {})
            .then(summary => {
              const entries = companyList.map(c => [c.key, summary[c.company] || null])
              setCompanyStock(Object.fromEntries(entries))
            })
        } else {
          setCompanyStock({})
        }
      })
      .finally(()=>setLoading(false))
  },[])

  if (loading) return <div className="dashboard-root">Loading dashboard…</div>

  return (
    <div className="dashboard-root">
      <header className="dashboard-header dashboard-header-centered">
        <div className="dash-title-block" style={{display:'flex',alignItems:'center',gap:32}}>
          <img src="/assets/kanikafavicon.png" alt="Kanika Logo" style={{height:90,width:'auto',borderRadius:20,boxShadow:'0 4px 24px rgba(0,0,0,0.13)',background:'#fff',padding:8}} />
          <h1 className="milk-flow type-reveal" aria-label="Kanika Group of Companies">
            <span style={{'--i':1}}>K</span>
            <span style={{'--i':2}}>a</span>
            <span style={{'--i':3}}>n</span>
            <span style={{'--i':4}}>i</span>
            <span style={{'--i':5}}>k</span>
            <span style={{'--i':6}}>a</span>
            <span style={{'--i':7}}>&nbsp;</span>
            <span style={{'--i':8}}>G</span>
            <span style={{'--i':9}}>r</span>
            <span style={{'--i':10}}>o</span>
            <span style={{'--i':11}}>u</span>
            <span style={{'--i':12}}>p</span>
            <span style={{'--i':13}}>&nbsp;</span>
            <span style={{'--i':14}}>o</span>
            <span style={{'--i':15}}>f</span>
            <span style={{'--i':16}}>&nbsp;</span>
            <span style={{'--i':17}}>C</span>
            <span style={{'--i':18}}>o</span>
            <span style={{'--i':19}}>m</span>
            <span style={{'--i':20}}>p</span>
            <span style={{'--i':21}}>a</span>
            <span style={{'--i':22}}>n</span>
            <span style={{'--i':23}}>i</span>
            <span style={{'--i':24}}>e</span>
            <span style={{'--i':25}}>s</span>
          </h1>
          <div style={{height: 10}} aria-hidden="true"></div>
          <div className="welcome-hello welcome-hello-center">Hello {user?.username || 'there'} 👋</div>
        </div>

        <div className="header-actions">
          <div className="user">Signed in as <strong>{user?.username}</strong></div>
          <div style={{display:'flex', gap:10, alignItems:'center'}}>
            <button className="btn secondary" style={{padding:'10px 16px', background:'#ffffff', borderColor:'#e5e7eb', color:'#0f172a', fontWeight:700, borderRadius:12, boxShadow:'0 8px 18px rgba(15,23,42,0.06)'}} onClick={()=>nav('/change-password')}>Change password</button>
            <button className="btn secondary" style={{padding:'10px 16px', background:'#ffffff', borderColor:'#e5e7eb', color:'#0f172a', fontWeight:700, borderRadius:12, boxShadow:'0 8px 18px rgba(15,23,42,0.06)'}} onClick={logout} disabled={loggingOut} aria-busy={loggingOut}>{loggingOut ? 'Logging out…' : 'Logout'}</button>
          </div>
        </div>
      </header>

      {/* Quick dashboards: visible to both admins and operators, now at the top */}
        {user && (isAdmin || isOperator || isSupervisor) && (
        <section className="quick-dashboards" style={{marginTop:18}}>
          <h3>Companies</h3>
          <div className="company-grid" style={isSupervisor && companiesForUser.length === 1 ? {gridTemplateColumns:'repeat(1, minmax(260px, 1fr))', justifyItems:'center'} : undefined}>
              {(companiesForUser.length ? companiesForUser : companies).map((c, idx) => {
                const summary = companyStock[c.key]
              const goodAll = summary?.returnCanGoodAll ?? summary?.returnCanGood ?? null
              const damageAll = summary?.returnCanDamageAll ?? summary?.returnCanDamage ?? null
              const supervisorHighlight = isSupervisor && companiesForUser.length === 1
              return (
                <div
                  key={c.key}
                  className="card company-card"
                  onClick={()=>nav(c.path)}
                  role="button"
                  tabIndex={0}
                  style={supervisorHighlight ? {
                    boxShadow:'0 0 0 4px rgba(37,99,235,0.45)',
                    animation:'pulse-border-strong 1.15s ease-in-out infinite',
                    filter:'drop-shadow(0 8px 18px rgba(59,130,246,0.25))'
                  } : undefined}
                >
                  <div className="card-title">{c.name}</div>
                  <div className="card-value" style={supervisorHighlight ? {fontSize:15,fontWeight:800,color:'#0f172a'} : undefined}>
                    {supervisorHighlight ? 'Click to view your can stock details' : <span style={{color:'#2563eb'}}>Open dashboard</span>}
                  </div>
                  {!isSupervisor && (
                    <div className="mini-stock">
                      <div className="mini-stock-row">
                        <div className="mini-stock-block">
                          <div className="mini-stock-label"><span style={{color:'#22c55e',fontWeight:700}}>Available Good Cans</span></div>
                          {goodAll === null ? (
                            <div className="mini-stock-empty">Data unavailable</div>
                          ) : (
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                              <img src="/assets/milkcan.png" alt="Milk Can" style={{width:48,height:'auto',marginBottom:4}} />
                              <div className="can-count">{goodAll}</div>
                            </div>
                          )}
                        </div>

                        <div className="mini-stock-block">
                          <div className="mini-stock-label"><span style={{color:'#ef4444',fontWeight:700}}>Damaged Cans</span></div>
                          {damageAll === null ? (
                            <div className="mini-stock-empty">Data unavailable</div>
                          ) : (
                            <div style={{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
                              <img src="/assets/milkcan.png" alt="Damaged Milk Can" style={{width:48,height:'auto',marginBottom:4,filter:'grayscale(1)'}} />
                              <div className="can-count damage">{damageAll}</div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </section>
      )}

      {isAdmin && (
        <div style={{display:'flex', justifyContent:'center', margin:'36px 0 12px'}}>
          <button
            className="btn primary"
            onClick={()=>nav('/admin-panel')}
            style={{
              padding:'24px 42px',
              fontSize:20,
              fontWeight:900,
              borderRadius:20,
              minWidth:360,
              background:'#4338ca',
              color:'#ffffff',
              border:'1px solid rgba(255,255,255,0.22)',
              boxShadow:'0 22px 54px rgba(67,56,202,0.35)',
              letterSpacing:0.65,
              animation:'admin-pulse 2.6s ease-in-out infinite',
              transition:'transform 180ms ease, box-shadow 180ms ease',
            }}
            onMouseEnter={e=>{e.currentTarget.style.transform='translateY(-3px) scale(1.02)'; e.currentTarget.style.boxShadow='0 26px 68px rgba(67,56,202,0.42)';}}
            onMouseLeave={e=>{e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 22px 54px rgba(67,56,202,0.35)';}}
          >
            Open admin panel
          </button>
        </div>
      )}

    </div>
  )
}